const Conditions = (props) => {

  let conditions = props.data?.synonyms;
  let conditionText = "";

  if (conditions && conditions.length > 0) {
    for(var i = 0; i < conditions.length; i++){
      let tempCond = conditions[i];
      conditionText += tempCond.name
      if(i < conditions.length - 1){
        conditionText += ", "
      }
    }

  }
  return (
    <div>{conditionText}</div>
  );
};

export default Conditions;